import type { ReactNode } from 'react';

import { TableFilterTags } from './TableFilterTags';
import { menuFilterTagsStyle, tableMenuStyle } from './TableMenu.css';

export type Props = {
  children: ReactNode;
};

export const TableMenu = ({ children }: Props) => {
  return (
    <div className={tableMenuStyle}>
      {children}

      {/* On mobile, the tags are rendered inside the filters drawer instead */}
      <div className={menuFilterTagsStyle}>
        <TableFilterTags />
      </div>
    </div>
  );
};
